if (!customElements.get('eclat-product-focus')) {
  customElements.define('eclat-product-focus', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-focus-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-focus-dot]'));
      this.index = 0;
      this.querySelector('[data-focus-prev]')?.addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-focus-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.focusDot))));
      this.addEventListener('keydown', event => {
        if (event.target.closest('input,textarea,select')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-focus-slide]');
        if (slide) this.show(this.slides.indexOf(slide));
      });
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      const status = this.querySelector('[data-focus-status]');
      if (status) status.textContent = status.dataset.label.replace('[number]', this.index + 1);
    }
  });
}
